export default "__VITE_ASSET__CgNQaO4f__"